<template>
    <div class="pagination" v-if="total > 1">
      <a class="pagination__item" v-if="page != 1" @click.prevent="changePage(+value - 1)"><i class="i i-left i-4"></i></a>
      <a :class="['pagination__item', {'pagination__item--active': page == item }]" v-for="item in pages" :key="item" @click.prevent="changePage(item)">
        {{item}}
      </a>
      <a class="pagination__item" v-if="page != total" @click.prevent="changePage(+value + 1)"><i class="i i-right i-4"></i></a>

      <div class="pagination__up" @click="up"><i class="i i-top i-4"></i></div>
    </div>    
</template>


<style lang="scss">
.pagination {
  width: 100%;
  margin-top: 15px;
  display: flex;
  &__item {
    cursor: pointer;
    height: 30px;
    min-width: 30px;
    align-items: center;
    display: inline-flex;
    padding: 0 8px;
    margin-right: 5px;
    justify-content: center;
    color: $color-link;
    background: $color-background-overlay;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    @include mq('md') {
      min-width: 50px;
      height: 50px;
    }
    &--active {
      background: $color-main;
      color: $color-link-hover;
      &:hover {
        color: $color-link-hover;
      }
    }
  }
  &__up {
    @extend .pagination__item;
    margin-left: auto;
    margin-right: 0;
  }
}

</style>

<script>
export default { 
    data() {
      return {}
    },
    props: {
        total: String,
        page: String
    },
    methods: {
      up() {
        document.body.scrollIntoView({ 
          behavior: 'smooth' 
        });
      },
      changePage(page) {
        window.location.search = '?page='+page;
      }
    },
    computed: {
        pages(first, last, items = []) {
          let total = parseInt(this.total);
          let page = parseInt(this.page);

          if(total > 5) {
            last = page < 3 ? 5 : page + 2;
            first = page >= 3 ? page - 2 : 1;
            
            if (last >= total) {
              first = Math.min(first, total - 4);
              last = total;
            }
          } else {
            first = 1;
            last = total;
          }
          for (let i = first; i <= last; i++) {
            items.push(i)
          }
          return items;
        }
    },
}
</script>
